import { ADVISOR_AGREEMENT_FRAGMENT } from '@src/gql/fragments/AdvisorAgreementFragment'
import { gql } from '@src/lib/gql'

export const SEND_ADVISOR_AGREEMENT = gql`
  mutation SendAdvisorAgreement($input: SendAdvisorAgreementInput!) {
    sendAdvisorAgreement(input: $input) {
      advisorAgreement {
        ...AdvisorAgreementFragment
      }
    }
  }
  ${ADVISOR_AGREEMENT_FRAGMENT}
`
